import commonResourceTh from '../../../locales/th/common.json';
import commonResourceEn from '../../../locales/en/common.json';

const tolPropertyTypesLocale = commonResourceTh.propertyTypes;
const projectnetPropertyTypesLocaleTh = commonResourceTh.projectnetTypes;
const projectnetPropertyTypesLocaleEn = commonResourceEn.projectnetTypes;

export enum PropertyType {
  Condominium = 'CD',
  House = 'HS',
  Townhome = 'TH',
  HolidayHomes = 'HH',
  HomeOffice = 'HO',
  MixedUse = 'MU',
  Commercial = 'CO',
}

export const projectNetTypeMapping: Record<string, string[]> = {
  [PropertyType.Condominium]: ['CONDO'],
  [PropertyType.House]: ['BUNG'],
  [PropertyType.Townhome]: ['TOWN'],
  [PropertyType.HolidayHomes]: ['VIL'],
  [PropertyType.HomeOffice]: ['BIZ'],
  [PropertyType.Commercial]: ['BIZ'],
  [PropertyType.MixedUse]: ['CONDO', 'BUNG', 'TOWN', 'VIL', 'APT'],
};

const propertyTypeMappings = new Map<PropertyType, string[]>([
  [
    PropertyType.Condominium,
    [
      tolPropertyTypesLocale.condominium,
      projectnetPropertyTypesLocaleTh.condo,
      projectnetPropertyTypesLocaleEn.condo,
    ],
  ],
  [
    PropertyType.House,
    [
      tolPropertyTypesLocale.house,
      projectnetPropertyTypesLocaleTh.detachedHouse,
      projectnetPropertyTypesLocaleEn.detachedHouse,
    ],
  ],
  [
    PropertyType.Townhome,
    [
      tolPropertyTypesLocale.townhome,
      projectnetPropertyTypesLocaleTh.townhouse,
      projectnetPropertyTypesLocaleEn.townhouse,
    ],
  ],
  [
    PropertyType.HolidayHomes,
    [
      tolPropertyTypesLocale.holidayHomes,
      projectnetPropertyTypesLocaleTh.villa,
      projectnetPropertyTypesLocaleEn.villa,
    ],
  ],
  [
    PropertyType.HomeOffice,
    [
      tolPropertyTypesLocale.homeOffice,
      projectnetPropertyTypesLocaleTh.business,
      projectnetPropertyTypesLocaleEn.business,
    ],
  ],
  [
    PropertyType.MixedUse,
    [
      tolPropertyTypesLocale.mixedUse,
      projectnetPropertyTypesLocaleTh.apartment,
      projectnetPropertyTypesLocaleEn.apartment,
    ],
  ],
  [
    PropertyType.Commercial,
    [
      tolPropertyTypesLocale.commercial,
      projectnetPropertyTypesLocaleTh.business,
      projectnetPropertyTypesLocaleEn.business,
    ],
  ],
]);

const valueToPropertyTypeMap = new Map<string, PropertyType>();
propertyTypeMappings.forEach((values, propertyType) => {
  values.forEach((value) => {
    valueToPropertyTypeMap.set(value, propertyType);
  });
});

const getPropertyTypeFromValue = (value: string): PropertyType | undefined =>
  valueToPropertyTypeMap.get(value);

// Get all possible values (TOL, Thai, English) associated with a given PropertyType
export const getAllPropertyTypeValues = (
  propertyType: PropertyType,
): string | undefined => propertyTypeMappings.get(propertyType)?.[0];

// Decode a URL segment and retrieve the corresponding PropertyType
export const getPropertyTypeFromUrlSegment = (
  propertyTypeSegment: string,
): PropertyType | undefined =>
  getPropertyTypeFromValue(decodeURIComponent(propertyTypeSegment));
